// src/pages/Register.js
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../api/auth';
import { loginThunk } from '../auth/authSlice';

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');

  // --------------------------
  // Validation
  // --------------------------
  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = 'Name is required';
    if (!mobile.trim()) newErrors.mobile = 'Mobile number is required';
    else if (!/^\d{10}$/.test(mobile)) newErrors.mobile = 'Enter a valid 10-digit number';
    if (!email.trim()) newErrors.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = 'Enter a valid email';
    if (!password) newErrors.password = 'Password is required';
    else if (password.length < 6) newErrors.password = 'Password must be at least 6 characters';
    return newErrors;
  };

  // --------------------------
  // Register Handler
  // --------------------------
  const handleRegister = async (e) => {
    e.preventDefault();

    const formErrors = validate();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setErrors({});
    setSuccess('');

    try {
      // 1️⃣ REGISTER
      const regRes = await registerUser({ name, mobile, email, password });
      if (regRes.status !== 'success') {
        throw new Error(regRes.message || 'Registration failed');
      }

      // 2️⃣ LOGIN via Redux Thunk
      const resultAction = await dispatch(loginThunk({ username: mobile, password }));
      if (loginThunk.rejected.match(resultAction)) {
        throw new Error(resultAction.payload || 'Login failed after registration');
      }

      setSuccess('Registration successful! Logging you in...');
      setTimeout(() => navigate('/'), 1500);
    } catch (err) {
      setErrors({ api: err.message });
    }
  };

  // --------------------------
  // UI
  // --------------------------
  return (
    <div className="d-flex align-items-center justify-content-center vh-100" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="login-box" style={{ width: 420, fontSize: '14px' }}>
        <div className="card card-outline card-primary">
          <div className="card-header text-center" style={{ fontSize: '28px', fontWeight: '600' }}>
            <a href="#"><b>Aadhav</b> Academy</a>
          </div>
          <div className="card-body">
            <p className="login-box-msg" style={{ fontSize: '16px' }}>Register a new account</p>

            <div className="alert alert-info py-2" style={{ fontSize: '13px' }}>
  📱 <strong>Mobile number will be your username</strong><br />
  🔐 Please remember your password for future login
</div>

            {errors.api && <div className="alert alert-danger">{errors.api}</div>}
            {success && <div className="alert alert-success">{success}</div>}

            <form onSubmit={handleRegister}>
              {/* NAME */}
              <div className="input-group mb-3">
                <input type="text" className="form-control" placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} />
                <div className="input-group-append"><div className="input-group-text"><span className="fas fa-user" /></div></div>
              </div>
              {errors.name && <small className="text-danger mb-2 d-block">{errors.name}</small>}

              {/* MOBILE */}
              <div className="input-group mb-3">
                <input type="tel" className="form-control" placeholder="Mobile Number" value={mobile} onChange={(e) => setMobile(e.target.value)} />
                <div className="input-group-append"><div className="input-group-text"><span className="fas fa-phone" /></div></div>
              </div>
              {errors.mobile && <small className="text-danger mb-2 d-block">{errors.mobile}</small>}

              {/* EMAIL */}
              <div className="input-group mb-3">
                <input type="email" className="form-control" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                <div className="input-group-append"><div className="input-group-text"><span className="fas fa-envelope" /></div></div>
              </div>
              {errors.email && <small className="text-danger mb-2 d-block">{errors.email}</small>}

              {/* PASSWORD */}
              <div className="input-group mb-3">
                <input type="password" className="form-control" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                <div className="input-group-append"><div className="input-group-text"><span className="fas fa-lock" /></div></div>
              </div>
              {errors.password && <small className="text-danger mb-2 d-block">{errors.password}</small>}

              <button type="submit" className="btn btn-primary btn-block" style={{ fontSize: '15px', fontWeight: '500' }}>Register</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
